export default "__VITE_ASSET__CNFyh0Tk__"